import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=b409dbfa&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MemberList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MemberList.vue?vue&type=style&index=0&id=b409dbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b409dbfa",
  null
  
)

export default component.exports